export enum StopTypeEnum {
  pickup = 'Pickup',
  delivery = 'Delivery',
}

export enum StopTypeEnumLowercase {
  pickup = 'pickup',
  delivery = 'delivery',
}
